
/* injects from baggage-loader */

'use strict';

const shared = angular.module('core.shared', []);

import constants from './constants';
import errors from './errors';
import usStates from './services/usstates.factory';
import countries from './services/countries.factory';
import faqs from './faqs';

// Parse Objects
import ParseService from './services/parse.service';
import UserService from './services/user.service';
import ProjectService from './services/projects.service';
import ProfileService from './services/profiles.service';
import InvestmentService from './services/investments.service';
import MediaService from './services/media.service';
import DocumentService from './services/documents.service';
import CommentService from './services/comments.service';

import ProfileSchema from './schemas/profile.schema';
import ProjectSchema from './schemas/project.schema';

import AlertsService from './services/alerts.service';
import ErrorHandlerService from './services/errorhandler.service';

import PercentageFilter from './filters/percentage.filter';
import TelephoneFilter from './filters/telephone.filter';
import SocialSecurityDirective from './directives/ssninput.directive';
import DynamicHeadingDirective from './directives/dynamicHeading/dynamicheading.directive';

import investmentWizardService from './services/investment-wizard.service';
import dynamicformDirective from './directives/dynamicForm/dynamicform.directive';
import blurofffocusDirective from './directives/blurOffFocus/blurofffocus.directive';
import scrollshowDirective from './directives/scrollShow/scrollshow.directive';



// ====================================================
// Connect services to the app
// ====================================================

// Directives
SocialSecurityDirective(shared);
blurofffocusDirective(shared);
dynamicformDirective(shared);
scrollshowDirective(shared);
DynamicHeadingDirective(shared);

// Services
ParseService(shared);
UserService(shared);
ProjectService(shared);
ProfileService(shared);
InvestmentService(shared);
MediaService(shared);
DocumentService(shared);
CommentService(shared)

investmentWizardService(shared);
AlertsService(shared);
ErrorHandlerService(shared);

// Schemas
ProfileSchema(shared);
ProjectSchema(shared);



// Filters
PercentageFilter(shared);
TelephoneFilter(shared);

// Others
constants(shared);
errors(shared);
usStates(shared);
countries(shared);
faqs(shared);


export default shared;


// WEBPACK FOOTER //
// ./src/app/core/core.module.js